<div class="file alternate">
  <input
    #nativeInput
    type="file"
    [attr.id]="inputId()"
    class="file-input"
    [accept]="accept()"
    [multiple]="multiple()"
    [disabled]="disabled()"
    (change)="onFileUpload($event)"
  />
  <div class="upload-icon">
    <app-upload-cloud-icon height="20px" width="20px" color="var(--gray-600)" />
  </div>
  <span>
    <span class="highlighted-text" i18n>Cliquez pour télécharger </span>
    @if (multiple()) {
      <ng-container i18n>ou glissez des fichiers</ng-container>
    } @else {
      <ng-container i18n>ou glissez un fichier</ng-container>
    }
  </span>
</div>

@if (rejectedNames().length) {
  <div class="invalid mt-8">
    @if (rejectedNames().length > 1) {
      <ng-container i18n
        >« {{ rejectedNames().join(' », « ') }} » ne sont pas des types de
        fichier autorisés.</ng-container
      >
    } @else {
      <ng-container i18n
        >« {{ rejectedNames()[0] }} » n'est pas un type de fichier
        autorisé.</ng-container
      >
    }
  </div>
}

@if (files().length) {
  <div class="mt-28">
    <span class="mb-16 file-label">
      @if (files().length > 1) {
        <ng-container i18n>Documents téléchargés</ng-container>
      } @else {
        <ng-container i18n>Document téléchargé</ng-container>
      }
    </span>
    @for (file of files(); track $index) {
      <div class="uploaded-file-container" [class.mt-8]="!$first">
        <div class="uploaded-file-element">
          <app-file-icon height="20px" width="20px" color="var(--gray-400)" />
          <div class="file-name">
            <span>{{ file.name }}</span>
            <span>{{ file.size | fileSize: 1 }}</span>
          </div>
          <app-check-circle-icon
            height="16px"
            width="16px"
            color="var(--success-500)"
          />
        </div>
        <app-trash-icon
          *ngIf="!disabled()"
          class="clickable"
          height="24px"
          width="24px"
          color="var(--gray-400)"
          (click)="removeFileAt($index)"
          (keydown.enter)="removeFileAt($index)"
          (keydown.space)="removeFileAt($index)"
          tabindex="0"
          role="button"
        />
      </div>
    }
  </div>
}
